<label *ngIf="visible$ | async" [for]="for" class="col-form-label label-quantity">{{
  translationKey | translate
}}</label>
